import "@/App.css";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import AboutVideo from "@/components/site/AboutVideo";
import SongSection from "@/components/site/SongSection";
import Platform from "@/components/site/Platform";
import Endorsements from "@/components/site/Endorsements";
import News from "@/components/site/CampaignCalendar";
import Ward3Communities from "@/components/site/Ward3Communities";
import GetInvolved from "@/components/site/GetInvolved";
import Footer from "@/components/site/Footer";

function HomePage() {
  return (
    <main className="bg-royal-deep min-h-screen">
      <Navbar />
      <Hero />
      <AboutVideo />
      <SongSection />
      <Platform />
      <Ward3Communities />
      <Endorsements />
      <News />
      <GetInvolved />
      <Footer />
    </main>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1B0640",
              color: "#F5F1EA",
              border: "1px solid rgba(245,241,234,0.2)",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
